/**
 * Admin Dark Mode — EINE Quelle der Wahrheit für den ganzen /admin-Bereich.
 *
 * - Präferenz: localStorage `brain_dark` ("1" = dunkel). Der Key bleibt aus
 *   Kompatibilität zum früheren Brain-only-Toggle (Präferenzen überleben).
 * - Cross-Tab + Cross-Komponente: Custom-Event `brain-dark-change` + `storage`.
 * - Die Klasse `dark` wird auf <html> gesetzt (nicht auf ein Div), damit auch
 *   Radix-Portale (Dialog, Select, Tooltip, Toast) dunkel sind. Setzen/Entfernen
 *   übernimmt AdminLayout (nur solange der Admin-Bereich gemountet ist — das
 *   Kundenportal nutzt dieselben ink-Tokens und darf nie dunkel werden).
 * - Anti-Flash: index.html setzt die Klasse vor dem Bundle (nur auf /admin-Pfaden).
 */
import { useSyncExternalStore } from "react";

const KEY = "brain_dark";
const EVENT = "brain-dark-change";

export function readAdminDark(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setAdminDark(dark: boolean): void {
  try {
    localStorage.setItem(KEY, dark ? "1" : "0");
  } catch {
    /* ignore (Private Mode o. ä.) */
  }
  window.dispatchEvent(new Event(EVENT));
}

export function toggleAdminDark(): void {
  setAdminDark(!readAdminDark());
}

function subscribe(cb: () => void) {
  window.addEventListener(EVENT, cb);
  window.addEventListener("storage", cb);
  return () => {
    window.removeEventListener(EVENT, cb);
    window.removeEventListener("storage", cb);
  };
}

/** Reaktiver Lesezugriff — funktioniert überall, auch außerhalb von AdminLayout (z. B. Sonner). */
export function useAdminDark(): boolean {
  return useSyncExternalStore(subscribe, readAdminDark, () => false);
}

/** Setzt/entfernt `dark` auf <html>. Rückgabe = Cleanup (entfernt die Klasse wieder). */
export function applyHtmlDarkClass(dark: boolean): () => void {
  const el = document.documentElement;
  el.classList.toggle("dark", dark);
  return () => el.classList.remove("dark");
}
